import React from 'react';

const PrivateCard = React.forwardRef(({ cardFrameClass }, ref) => {
  return (
    <div ref={ref} className={`user-card private ${cardFrameClass}`}>
      <div className="private-icon">🔒</div>
      <div className="private-text">Приватный профиль</div>
    </div>
  );
});

PrivateCard.displayName = 'PrivateCard';

export default PrivateCard;